import { UsersCollectionReducerState } from './types';

export const getDefaultState = (): UsersCollectionReducerState => ({
  userListResponse: {}
});
